import AbstractService from './AbstractService';
import store from '../store/store';
import Dotize from './Dotize';

export default class UserService extends AbstractService {
  url(url) {
    return `/users${url}`;
  }

  getUsers() { // for absence
    const data = this.http.get(this.url('/all'));
    return data;
  }
  getEmployeesUnderIncharge(ref) { // for absence
    const data = this.http.get(this.url(`/employee/incharge/${ref}`));
    return data;
  }

  async employeeForParticularGroup(url, flag) {
    const params = {};
    params.all = flag;
    const data = await this.http.get(this.url(url), { params });
    return data;
  }
  async getUserData(reference) {
    const data = await this.http.get(this.url(`/${reference}`));
    return data;
  }
  getPhoneNo(reference) {
    const data = this.http.get(this.url(`/${reference}`));
    return data;
  }

  findAllInCharge() {
    return this.http.get(this.url('/all/inCharge'));
  }

  login(email, password) {
    return this.http.post(this.url('/login'), {
      email,
      password,
    })
      .then(async (data) => {
        await store.dispatch('loginUser', data.data);
      });
  }

  logout() {
    return this.http.post(this.url('/logout'))
      .then(() => {
        store.commit('logoutUser');
      });
  }

  tokenPassword(token) {
    return this.http.post(this.url('/password'), token);
  }

  myAccount() {
    return this.http.get(this.url('/myAccount'));
  }

  myAvatar(avatar) {
    return this.http.post(this.url('/myAvatar'), avatar);
  }

  updateMyAccount(body) {
    return this.http.put(this.url('/myAccount'), body);
  }

  updateMyPassword(body) {
    return this.http.put(this.url('/myAccount/password'), body);
  }

  resetPassword(body) {
    return this.http.post(this.url('/resetPassword'), body);
  }

  updateLeftVacations(body) {
    return this.http.post(this.url('/updateLeftVacations'), body);
  }

  deleteUser(reference) {
    return this.http.delete(this.url(`/${reference}`));
  }

  _modelToQuery(model) {
    const query = Object.assign({}, model);
    if (model.email) { query.email = `text|.*${model.email}.*`; }
    if (model.firstName) { query.firstName = `text|.*${model.firstName}.*`; }
    if (model.lastName) { query.lastName = `text|.*${model.lastName}.*`; }
    // Dotize after for complex objet !
    model = Dotize.convert(model);
    if (model['permissions.groupReference']) {
      query['permissions.groupReference'] = `in|${model['permissions.groupReference']}`;
    }
    return query;
  }
}
